export enum XboxNetworkAddOns {
  dlcPacks = "dlcPacks",
  durables = "durables",
  consumables = "consumables",
  freeAddOnContent = "freeAddOnContent",
  inGameSubscriptions = "inGameSubscriptions",
}
